import PropTypes from 'prop-types';
import React from 'react';
import { isValidEmail } from '../../utils';
// @mui/icons-material
import Email from '@mui/icons-material/Email';
import Face from '@mui/icons-material/Face';
import RecordVoiceOver from '@mui/icons-material/RecordVoiceOver';

// @mui/material components
import InputAdornment from '@mui/material/InputAdornment';
import withStyles from '@mui/styles/withStyles';

// core components
import CustomInput from 'components/CustomInput/CustomInput.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';

const style = {
  infoText: {
    fontWeight: '300',
    margin: '10px 0 30px',
    textAlign: 'center',
  },
  inputAdornmentIcon: {
    color: '#555',
  },
  inputAdornment: {
    position: 'relative',
  },
};

class Step2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      nameState: '',
      phone: '',
      phoneState: '',
      email: '',
      emailState: '',
    };
  }
  sendState() {
    return this.state;
  }
  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  change(event, stateName, type, stateNameEqualTo) {
    switch (type) {
      case 'email':
        if (isValidEmail(event.target.value)) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      case 'length':
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  }
  isValidated() {
    if (
      this.state.nameState === 'success' &&
      this.state.phoneState === 'success' &&
      this.state.emailState === 'success'
    ) {
      return true;
    } else {
      if (this.state.nameState !== 'success') {
        this.setState({ nameState: 'error' });
      }
      if (this.state.phoneState !== 'success') {
        this.setState({ phoneState: 'error' });
      }
      if (this.state.emailState !== 'success') {
        this.setState({ emailState: 'error' });
      }
    }
    return false;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify='center'>
        <GridItem xs={12} sm={12}>
          <h4 className={classes.infoText}>
            Provide contact information for billing
          </h4>
        </GridItem>
        <GridItem xs={12} sm={10}>
          <CustomInput
            success={this.state.nameState === 'success'}
            error={this.state.nameState === 'error'}
            labelText={
              <span>
                Full Name <small>(required)</small>
              </span>
            }
            id='name'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => this.change(event, 'name', 'length', 3),
              endAdornment: (
                <InputAdornment
                  position='end'
                  className={classes.inputAdornment}
                >
                  <Face className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
            }}
          />
          <CustomInput
            success={this.state.phoneState === 'success'}
            error={this.state.phoneState === 'error'}
            labelText={
              <span>
                Phone Number <small>(required)</small>
              </span>
            }
            id='phone'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => this.change(event, 'phone', 'length', 10),
              endAdornment: (
                <InputAdornment
                  position='end'
                  className={classes.inputAdornment}
                >
                  <RecordVoiceOver className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
            }}
          />
          <CustomInput
            success={this.state.emailState === 'success'}
            error={this.state.emailState === 'error'}
            labelText={
              <span>
                Email <small>(required)</small>
              </span>
            }
            id='email'
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              onChange: (event) => this.change(event, 'email', 'email'),
              endAdornment: (
                <InputAdornment
                  position='end'
                  className={classes.inputAdornment}
                >
                  <Email className={classes.inputAdornmentIcon} />
                </InputAdornment>
              ),
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12} lg={10}></GridItem>
      </GridContainer>
    );
  }
}

Step2.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(style)(Step2);
